import Graphic from "./Graphic";

export default function () {
	return (
		<>
			<Graphic />
		</>
	);
}
